import { useEffect, useState } from "react";
import axios from "axios";
import { ARTICLES } from "@/content/articles";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let cache = null;
const listeners = new Set();
const DEFAULTS = Object.fromEntries(ARTICLES.filter((a) => a.cover).map((a) => [a.slug, a.cover]));

export const refreshCovers = async () => {
  const { data } = await axios.get(`${BACKEND}/api/blog/covers`);
  cache = Object.fromEntries(Object.entries(data).map(([k, v]) => [k, `${BACKEND}${v}`]));
  listeners.forEach((fn) => fn(cache));
  return cache;
};

export const useCovers = ({ withDefaults = true } = {}) => {
  const [covers, setCovers] = useState(cache || {});
  useEffect(() => {
    listeners.add(setCovers);
    if (!cache) refreshCovers().catch(() => {});
    return () => listeners.delete(setCovers);
  }, []);
  return withDefaults ? { ...DEFAULTS, ...covers } : covers;
};
